import { useTracking } from '@change-corgi/core/react/tracking';

import { usePetitionDetailsPageData } from 'src/app/pages/petition/details/pageContext';
import { craftSupporterEmail } from 'src/app/shared/utils/decisionMaker';

type Result = ModelHookResult<
	{ emailHref: string; showContactCTA: boolean },
	{
		handleEmailDmClick: () => void;
	}
>;

type UseContactDmArgs = {
	displayName: string;
	email?: string | null;
};

export function useContactDM({ email, displayName }: UseContactDmArgs): Result {
	const {
		data: {
			petition: {
				slug,
				ask,
				signatureState: {
					signatureCount: { displayedLocalized: signatureCount },
				},
			},
			emailDm,
		},
	} = usePetitionDetailsPageData();

	const track = useTracking();

	const handleEmailDmClick = () => {
		void track('petition_page_email_dm_click');
	};

	const emailHref = craftSupporterEmail({
		dmEmail: email,
		dmName: displayName,
		ask,
		slug,
		signatureCount,
		emailDm,
	});

	const showContactCTA = !!email;

	return {
		data: {
			emailHref,
			showContactCTA,
		},
		actions: {
			handleEmailDmClick,
		},
	};
}
